import { supabase } from './supabase.ts';

/** Call a Netlify function with the caller's Supabase JWT attached. */
export async function callApi<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const res = await fetch(`/api/${path}`, {
    ...init,
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(init?.headers ?? {}),
    },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = (body as { error?: string }).error ?? `Request failed (${res.status})`;
    // #GR21: `details` may be a string[] (validation errors) OR an arbitrary object
    // (e.g. the lock's { deployStatus }). Never assume an array — a bare .join() on an
    // object threw "m.join is not a function", masking the real "not green yet" message.
    const details = (body as { details?: unknown }).details;
    const suffix = Array.isArray(details)
      ? `: ${details.join('; ')}`
      : details
        ? `: ${typeof details === 'string' ? details : JSON.stringify(details)}`
        : '';
    throw new Error(`${msg}${suffix}`);
  }
  return body as T;
}
